<template>
  <div class="max-w-448 w-full mx-auto my-24">
    <div class="px-16 sm:px-0">
      <Breadcrumb to="/account/deactivation/questionnaire" header="Back" :routerLink="true" />
      <h1 class="text-h3 sm:text-h2 mt-24">Why weren’t you able to hire someone?</h1>
      <p class="text-body mt-16">Choose all that apply</p>
    </div>
    <Card class="w-full mx-0 mt-24" :elevation="2">
      <form @submit.prevent="submitForm">
        <fieldset>
          <legend class="sr-only">Why weren't you able to hire someone?</legend>
          <ul>
            <li v-for="option in notSuccessfulReasons" :key="option.slug">
              <Checkbox
                :key="option.slug"
                v-model="questionnaireData.selectedNotSuccessfulReasons"
                :labelName="option.reason"
                :checkboxId="option.slug"
                :value="option.slug"
              />
            </li>
          </ul>
        </fieldset>
        <Button value="Next" variant="primary" size="medium" class="w-full mt-24" />
      </form>
    </Card>
  </div>
</template>

<script lang="ts">
import Breadcrumb from '../../../components/breadcrumb/Breadcrumb.vue';
import Card from '../../../components/card/Card.vue';
import Checkbox from '../../../components/checkbox/Checkbox.vue';
import Button from '../../../components/button/Button.vue';
import { Account } from '@/models/account';

export default {
  name: 'Survey',
  components: { Breadcrumb, Card, Checkbox, Button },
  props: {
    account: {
      required: true,
      type: Account,
    },
  },
  data(): any {
    return {
      questionnaireData: {
        matchSuccessful: false,
        matchedMembers: [],
        selectedNotSuccessfulReasons: [],
      },
    };
  },
  computed: {
    notSuccessfulReasons(): object[] {
      return [
        {
          reason: 'I found a sitter somewhere else',
          slug: 'found-elsewhere',
        },
        {
          reason: 'Not enough active sitters',
          slug: 'not-enough-sitters',
        },
        {
          reason: 'My needs changed',
          slug: 'needs-changed',
        },
        {
          reason: 'Sitter quality was too low',
          slug: 'low-sitter-quality',
        },
        {
          reason: 'Sittercity is too difficult to use',
          slug: 'too-difficult',
        },
      ];
    },
  },
  methods: {
    async submitForm() {
      sessionStorage.setItem('show_confirmation_page', 'true');
      // Also set a flag in the current URL as a backup
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('deactivation_completed', 'true');
      window.history.replaceState({}, '', currentUrl.toString());

      await this.$emit('updateQuestionnaire', this.questionnaireData);
      await this.$emit('closeAccount');
    },
  },
};
</script>
